import { GraphQLRequest } from "@rcsb/rcsb-api-tools/lib/RcsbGraphQL/GraphQLRequest";
import { SearchRequest } from "@rcsb/rcsb-api-tools/lib/RcsbSearch/SearchRequest";
export const rcsbRequestClient = {
    borrego: new GraphQLRequest("1d-coordinates"),
    yosemite: new GraphQLRequest("data-api"),
    arches: new SearchRequest()
};
//# sourceMappingURL=RcsbRequestClient.js.map